import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=329a80d8&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=329a80d8&prod&lang=scss"
import style1 from "./DocumentViewer.vue?vue&type=style&index=1&id=329a80d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a80d8",
  null
  
)

export default component.exports